export const CouponTargetType = {
    CENTER: "센터",
    TEACHER: "선생님",
    PARENT: "부모님",
} as const;
